import { Component, OnInit } from '@angular/core';
import {  MenuService } from '../../services/MenuService';
import { Menu } from '../../models/Menu';
import { CampusInfo } from '../../models/CampusInfo';

@Component({
    selector: 'footer',
    template: require('./FooterComponent.html'),
    styles: [require('./FooterComponent.sass')],
    providers: [ MenuService ]
})

export class FooterComponent {
    private menuList: Menu[];
    private campusList: CampusInfo[];
    private currentLang: string;
    
    constructor(private menuService: MenuService){ }
    
    ngOnInit () {
        /** TO DO 
         * Get current language from cookie/session
         * If no language data from it, set default language as English
         */
        this.currentLang = 'en';
        // Get top menu list
        this.menuList = this.menuService.getMenuList('top');
        // Get campus info list
        this.campusList = this.menuService.getCampusInfo();
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/components/footer/FooterComponent.ts